import type { TeamConferenceFilter } from '@on3/api';
import { useMemo } from 'react';

/** ACC, B1G, Big-12 (are they still a P5, lol), Independents, Pac-12, SEC */
const p5ConferenceIds = [2, 3, 4, 6, 9, 10];

/**
 * breaks out P5 conferences from the rest into two arrays \n
 * sorts all P5 by alpha, then the rest by alpha
 * flattens the two arrays back into one, while keeping the sort order in tact
 */
export const useSortedConferences = (conferences?: TeamConferenceFilter[]) =>
  useMemo(() => {
    if (conferences?.length) {
      return conferences
        .reduce(
          (acc, curr) => {
            if (p5ConferenceIds.includes(curr?.conferenceKey ?? -1)) {
              return [[...acc[0], curr], acc[1]];
            }

            return [acc[0], [...acc[1], curr]];
          },
          [[] as TeamConferenceFilter[], [] as TeamConferenceFilter[]],
        )
        .map((confGroup) =>
          confGroup.sort(
            (a, b) =>
              a.conferenceAbbr?.localeCompare(b.conferenceAbbr ?? '') ?? 0,
          ),
        )
        .flat();
    }

    return [];
  }, [conferences]);
